






























































import { Component, Vue } from "vue-property-decorator";
import { TransactionItem } from "@/domain/types/transactions_query";
import { PDFWriter } from "@/util/pdf";
import { domain, Company } from "@/domain";
import * as util from "@/util";
import { exportHtmlElement } from "@/util/download";

@Component
export default class TxnReceiptDialog extends Vue {
  // Receipt dialog
  receiptDialog = false;
  loadingReceipt = false;
  receiptTxn: TransactionItem | null = null;
  receiptData = {
    receiptText: "",
    signatureText: "",
    signatureImg: ""
  };

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  async showReceipt(item: TransactionItem) {
    this.receiptData.receiptText = "";
    this.loadingReceipt = true;
    this.receiptDialog = true;
    this.receiptTxn = item;
    try {
      if ((!this.currentCompany && !item.companyId) || !item.branchID || !item.id) {
        throw new Error("Missing company, branch or txn ID");
      }
      const txn = await domain.backend.getTransactionInfo({
        companyID: this.currentCompany?.id || item.companyId || 0,
        branchID: parseInt(item.branchID, 10),
        transactionID: item.id // '281781013'
      });
      if (!txn.transaction) {
        throw new Error("Transaction not found");
      }
      this.receiptData = {
        receiptText: txn.transaction.receiptText || "",
        signatureText: txn.transaction.signatureText || "",
        signatureImg: txn.transaction.signatureImage || ""
      };
    } catch (err) {
      util.logError("Error cargando el recibo", err);
      this.$emit("error", { msg: "No se pudo cargar el recibo", err });
    }
    this.loadingReceipt = false;
  }

  downloadReceiptPDF() {
    if (!this.receiptTxn) {
      return;
    }
    const writer = new PDFWriter();
    if (this.isContactless(this.receiptTxn)) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      writer.image(require("@/assets/contactless.png"), "center", 0);
    }
    const content = this.receiptData.receiptText + "\n\n" + this.receiptData.signatureText;
    writer.text(content, "center", 0, { fontSize: 10 });
    if (this.receiptData.signatureImg) {
      const signImg = `data:image/bmp;base64,${this.receiptData.signatureImg}`;
      writer.image(signImg, "center", 0, { format: "bmp" });
    }
    writer.save(`${this.lang.receipt} ${this.receiptTxn.id}.pdf`);
  }

  downloadReceiptPNG() {
    if (!this.receiptTxn) {
      return;
    }
    exportHtmlElement(`${this.lang.receipt} ${this.receiptTxn.id}`, this.$refs.receiptDiv as HTMLElement);
  }

  isContactless(txn: TransactionItem | null): boolean {
    if (!txn) return false;
    return txn.dataEntryCode === "X";
  }

  get receiptText(): string {
    if (!this.receiptData.receiptText) {
      return "";
    }
    return util.symbolsToTags(this.receiptData.receiptText);
  }

  get receiptSignatureText(): string {
    if (!this.receiptData.receiptText) {
      return "";
    }
    return util.symbolsToTags(this.receiptData.signatureText);
  }
}
